import { post } from 'common/utils/xhr';
import DraftStepStore from 'launch/stores/DraftStepStore';
import UrlStore from 'launch/stores/UrlStore';
import { browserHistory } from 'react-router';
import { trackEvent } from '@99designs/utils/platform';
import { STARTED_LAUNCH, VIEWED_LAUNCH_STEP } from 'launch/consts/trackEventNames';

export function clearStatus(ctx, payload) {
    ctx.dispatch('CLEAR_STATUS', payload);
}

export function toggleColor(ctx, payload) {
    ctx.dispatch('TOGGLE_COLOR', payload);
}

export function toggleDesign(ctx, payload) {
    ctx.dispatch('TOGGLE_DESIGN', payload);
}

export function updateCustomColors(ctx, payload) {
    ctx.dispatch('UPDATE_CUSTOM_COLORS', payload);
}

export function updateFieldValue(ctx, payload) {
    ctx.dispatch('UPDATE_FIELD_VALUE', payload);
}

export function saveDraft(ctx, payload={ options: {}, data: {} }) {
    let data = {
        ...payload.data,
        step: ctx.getStore(DraftStepStore).getCurrentStepId()
    };

    ctx.dispatch('SAVE_DRAFT_STARTED');
    let xhr = post(urlFor(ctx, 'updateDraft'), data);

    return new Promise((resolve, reject) => {
        xhr.end((error, res) => {
            if (error) {
                ctx.dispatch('SAVE_DRAFT_FAILURE', { error });
                reject({ error });
            } else {
                ctx.dispatch('SAVE_DRAFT_SUCCESS', {
                    ...res.body,
                    ...payload.options,
                });
                resolve();
            }
        });
    });
}

export function transitionToStep(ctx, step) {
    const contestsSteps = ['contestsBrief', 'contestsDetails', 'contestsPayment'];

    if (contestsSteps.indexOf(step) !== -1) {
        redirectTo(urlFor(ctx, step));
    } else {
        const url = ctx.getStore(DraftStepStore).urlForStep(step);
        browserHistory.push(url);
    }

    return Promise.resolve();
}

export function transitionToNextStep(ctx, payload={}) {
    function transition() {
        const nextStep = ctx.getStore(DraftStepStore).getNextStep();

        if (nextStep) {
            return ctx.executeAction(transitionToStep, nextStep);
        } else {
            return Promise.resolve();
        }
    }

    if (payload.saveAction) {
        return ctx.executeAction(payload.saveAction, payload).then(transition);
    } else {
        return transition();
    }
}

export function loadDraftData(ctx, payload, done) {
    ctx.dispatch('LOAD_DRAFT_DATA', payload);
    done();
}

export function loadDraftRoutes(ctx, payload, done) {
    ctx.dispatch('LOAD_DRAFT_STEPS', payload);
    done();
}

export function updateDraftStep(ctx, { step, params }) {
    ctx.dispatch('UPDATE_DRAFT_STEP', step);

    const stepStore = ctx.getStore(DraftStepStore);

    if (stepStore.isFirstStep()) {
        trackEvent(STARTED_LAUNCH, params)
    }

    trackEvent(VIEWED_LAUNCH_STEP, { step, ...params });
}

function urlFor(ctx, key) {
    return ctx.getStore(UrlStore).urlFor(key);
}

function redirectTo(url) {
    window.location.href = url;
}



// WEBPACK FOOTER //
// ./js/launch/actions/designBriefActions.js